// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Modern Communication / Chat View Styles
   LeistFusion Brand Palette (Teal / Slate / Sky)
   ============================================================ */

.communication-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #f8fafc;
  border-radius: 0;
  border: none;
  overflow: hidden;
  position: relative;
  font-family: inherit;
}

/* Header */
.communication-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid #eef2f6;
  flex-shrink: 0;
  z-index: 10;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.communication-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.comm-back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50% !important;
  color: #475569 !important;
  transition: all 0.2s ease !important;
}

.comm-back-btn:hover {
  background: #f1f5f9 !important;
  color: #0f172a !important;
}

.comm-header-avatar {
  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(21, 127, 159, 0.2);
  flex-shrink: 0;
}

.communication-header-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.communication-title {
  font-weight: 600;
  font-size: 15px;
  color: #0f172a;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.communication-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
  margin-top: 1px;
}

.comm-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
  display: inline-block;
  animation: pulse-dot 2s infinite;
}

.comm-status-dot.disconnected {
  background-color: #f59e0b;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);
  animation: none;
}

@keyframes pulse-dot {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(16, 185, 129, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

.comm-alert {
  margin: 10px 16px 0 16px;
  flex-shrink: 0;
  border-radius: 10px;
}

/* Messages Scroll Area */
.communication-messages-area {
  flex: 1 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: radial-gradient(circle at 50% 0%, #ffffff 0%, #f8fafc 100%);
}

.communication-messages-area::-webkit-scrollbar {
  width: 6px;
}

.communication-messages-area::-webkit-scrollbar-track {
  background: transparent;
}

.communication-messages-area::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.35);
  border-radius: 10px;
}

.communication-messages-area::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.6);
}

.comm-load-older {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.comm-load-older-btn {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  color: #64748b !important;
  border-radius: 16px !important;
  font-size: 12px !important;
  padding: 0 14px !important;
  height: 28px !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
  transition: all 0.2s ease !important;
}

.comm-load-older-btn:hover {
  color: #157f9f !important;
  border-color: #2a9dc0 !important;
  background: #f8fafc !important;
}

.comm-loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/* Empty State */
.comm-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px 20px;
  text-align: center;
}

.comm-empty-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: linear-gradient(135deg, #ecf7fb 0%, #d5eef6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  color: #157f9f;
  font-size: 26px;
  box-shadow: 0 4px 14px rgba(21, 127, 159, 0.12);
}

.comm-empty-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 6px;
}

.comm-empty-subtitle {
  font-size: 13px;
  color: #64748b;
  max-width: 320px;
  line-height: 1.5;
  margin: 0;
}

/* Message Rows */
.comm-message-row {
  display: flex;
  align-items: flex-end;
  margin-bottom: 12px;
  gap: 8px;
  position: relative;
  transition: transform 0.1s ease;
}

.comm-mine {
  flex-direction: row-reverse;
}

.comm-theirs {
  flex-direction: row;
}

.comm-avatar {
  flex-shrink: 0;
  margin-bottom: 2px;
}

.comm-avatar-mine {
  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);
}

.comm-avatar-theirs {
  background: #64748b;
}

.comm-message-content {
  max-width: 72%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.comm-mine .comm-message-content {
  align-items: flex-end;
}

.comm-theirs .comm-message-content {
  align-items: flex-start;
}

.comm-sender-name {
  font-size: 11px;
  font-weight: 600;
  color: #0e6580;
  margin-bottom: 3px;
  padding-left: 4px;
}

/* Bubbles */
.comm-bubble {
  padding: 10px 14px;
  font-size: 14px;
  line-height: 1.5;
  word-break: break-word;
  position: relative;
  transition: box-shadow 0.2s ease;
}

/* Mine: Vibrant gradient with rounded modern shape and soft shadow */
.comm-mine .comm-bubble {
  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);
  color: #ffffff;
  border-radius: 18px 18px 4px 18px;
  box-shadow: 0 2px 8px rgba(21, 127, 159, 0.22);
}

/* Theirs: Crisp modern card with soft border & subtle shadow */
.comm-theirs .comm-bubble {
  background: #ffffff;
  color: #1e293b;
  border: 1px solid #e2e8f0;
  border-radius: 18px 18px 18px 4px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}

.comm-bubble-deleted {
  background: #f1f5f9 !important;
  color: #94a3b8 !important;
  border-color: #e2e8f0 !important;
  font-style: italic;
  box-shadow: none !important;
}

.comm-deleted-text {
  font-size: 13px;
}

.comm-edited-tag {
  font-size: 10px;
  margin-left: 6px;
  padding: 0 4px;
  line-height: 16px;
  vertical-align: middle;
  border-radius: 4px;
}

.comm-mine .comm-edited-tag {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  border: none;
}

.comm-theirs .comm-edited-tag {
  background: #f1f5f9;
  color: #64748b;
  border: none;
}

/* Message Meta (Time & Status) */
.comm-bubble-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
  font-size: 11px;
}

.comm-mine .comm-bubble-footer {
  color: rgba(255, 255, 255, 0.8);
}

.comm-theirs .comm-bubble-footer {
  color: #94a3b8;
}

.comm-check-icon {
  font-size: 10px;
  margin-left: 2px;
}

/* Message Actions */
.comm-message-actions {
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease;
  display: flex;
  align-items: center;
  align-self: center;
  padding: 0 2px;
}

.comm-message-row:hover .comm-message-actions {
  opacity: 1;
}

.comm-msg-more-btn {
  color: #94a3b8 !important;
  border-radius: 50% !important;
  width: 28px !important;
  height: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: rgba(255, 255, 255, 0.8) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.comm-msg-more-btn:hover {
  color: #1e293b !important;
  background: #ffffff !important;
}

/* Composer */
.communication-composer {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 12px 18px 14px 18px;
  border-top: 1px solid #eef2f6;
  background: #ffffff;
  flex-shrink: 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.02);
}

.comm-textarea {
  border-radius: 20px !important;
  padding: 9px 16px !important;
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  resize: none !important;
  transition: all 0.2s ease !important;
  color: #1e293b !important;
}

.comm-textarea:focus,
.comm-textarea-focused {
  background: #ffffff !important;
  border-color: #2a9dc0 !important;
  box-shadow: 0 0 0 3px rgba(42, 157, 192, 0.15) !important;
}

.comm-send-button {
  height: 40px !important;
  width: 40px !important;
  min-width: 40px !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%) !important;
  border: none !important;
  box-shadow: 0 3px 10px rgba(21, 127, 159, 0.28) !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  color: #ffffff !important;
  padding: 0 !important;
}

.comm-send-button:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 5px 14px rgba(21, 127, 159, 0.38) !important;
  background: linear-gradient(135deg, #38abd0 0%, #178aa8 100%) !important;
}

.comm-send-button:active:not(:disabled) {
  transform: translateY(0) !important;
}

.comm-send-button:disabled {
  background: #e2e8f0 !important;
  color: #94a3b8 !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/commons/Communication/components/CommunicationView.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,cAAc;EACd,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,6CAA6C;EAC7C,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uEAAuE;AACzE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,qEAAqE;AACrE;EACE,6DAA6D;EAC7D,cAAc;EACd,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+CAA+C;EAC/C,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,wEAAwE;EACxE,uBAAuB;EACvB,0DAA0D;EAC1D,4DAA4D;EAC5D,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,0DAA0D;EAC1D,wEAAwE;AAC1E;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B","sourcesContent":["/* ============================================================\n   Modern Communication / Chat View Styles\n   LeistFusion Brand Palette (Teal / Slate / Sky)\n   ============================================================ */\n\n.communication-view {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  background: #f8fafc;\n  border-radius: 0;\n  border: none;\n  overflow: hidden;\n  position: relative;\n  font-family: inherit;\n}\n\n/* Header */\n.communication-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-bottom: 1px solid #eef2f6;\n  flex-shrink: 0;\n  z-index: 10;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);\n}\n\n.communication-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.comm-back-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50% !important;\n  color: #475569 !important;\n  transition: all 0.2s ease !important;\n}\n\n.comm-back-btn:hover {\n  background: #f1f5f9 !important;\n  color: #0f172a !important;\n}\n\n.comm-header-avatar {\n  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 2px 6px rgba(21, 127, 159, 0.2);\n  flex-shrink: 0;\n}\n\n.communication-header-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.communication-title {\n  font-weight: 600;\n  font-size: 15px;\n  color: #0f172a;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.communication-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 1px;\n}\n\n.comm-status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background-color: #10b981;\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n  display: inline-block;\n  animation: pulse-dot 2s infinite;\n}\n\n.comm-status-dot.disconnected {\n  background-color: #f59e0b;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.2);\n  animation: none;\n}\n\n@keyframes pulse-dot {\n  0% {\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 5px rgba(16, 185, 129, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n  }\n}\n\n.comm-alert {\n  margin: 10px 16px 0 16px;\n  flex-shrink: 0;\n  border-radius: 10px;\n}\n\n/* Messages Scroll Area */\n.communication-messages-area {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background: radial-gradient(circle at 50% 0%, #ffffff 0%, #f8fafc 100%);\n}\n\n.communication-messages-area::-webkit-scrollbar {\n  width: 6px;\n}\n\n.communication-messages-area::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.communication-messages-area::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.35);\n  border-radius: 10px;\n}\n\n.communication-messages-area::-webkit-scrollbar-thumb:hover {\n  background: rgba(148, 163, 184, 0.6);\n}\n\n.comm-load-older {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.comm-load-older-btn {\n  background: #ffffff !important;\n  border: 1px solid #e2e8f0 !important;\n  color: #64748b !important;\n  border-radius: 16px !important;\n  font-size: 12px !important;\n  padding: 0 14px !important;\n  height: 28px !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;\n  transition: all 0.2s ease !important;\n}\n\n.comm-load-older-btn:hover {\n  color: #157f9f !important;\n  border-color: #2a9dc0 !important;\n  background: #f8fafc !important;\n}\n\n.comm-loading-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n/* Empty State */\n.comm-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.comm-empty-icon-wrap {\n  width: 64px;\n  height: 64px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #ecf7fb 0%, #d5eef6 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  color: #157f9f;\n  font-size: 26px;\n  box-shadow: 0 4px 14px rgba(21, 127, 159, 0.12);\n}\n\n.comm-empty-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 6px;\n}\n\n.comm-empty-subtitle {\n  font-size: 13px;\n  color: #64748b;\n  max-width: 320px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n/* Message Rows */\n.comm-message-row {\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 12px;\n  gap: 8px;\n  position: relative;\n  transition: transform 0.1s ease;\n}\n\n.comm-mine {\n  flex-direction: row-reverse;\n}\n\n.comm-theirs {\n  flex-direction: row;\n}\n\n.comm-avatar {\n  flex-shrink: 0;\n  margin-bottom: 2px;\n}\n\n.comm-avatar-mine {\n  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);\n}\n\n.comm-avatar-theirs {\n  background: #64748b;\n}\n\n.comm-message-content {\n  max-width: 72%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.comm-mine .comm-message-content {\n  align-items: flex-end;\n}\n\n.comm-theirs .comm-message-content {\n  align-items: flex-start;\n}\n\n.comm-sender-name {\n  font-size: 11px;\n  font-weight: 600;\n  color: #0e6580;\n  margin-bottom: 3px;\n  padding-left: 4px;\n}\n\n/* Bubbles */\n.comm-bubble {\n  padding: 10px 14px;\n  font-size: 14px;\n  line-height: 1.5;\n  word-break: break-word;\n  position: relative;\n  transition: box-shadow 0.2s ease;\n}\n\n/* Mine: Vibrant gradient with rounded modern shape and soft shadow */\n.comm-mine .comm-bubble {\n  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%);\n  color: #ffffff;\n  border-radius: 18px 18px 4px 18px;\n  box-shadow: 0 2px 8px rgba(21, 127, 159, 0.22);\n}\n\n/* Theirs: Crisp modern card with soft border & subtle shadow */\n.comm-theirs .comm-bubble {\n  background: #ffffff;\n  color: #1e293b;\n  border: 1px solid #e2e8f0;\n  border-radius: 18px 18px 18px 4px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);\n}\n\n.comm-bubble-deleted {\n  background: #f1f5f9 !important;\n  color: #94a3b8 !important;\n  border-color: #e2e8f0 !important;\n  font-style: italic;\n  box-shadow: none !important;\n}\n\n.comm-deleted-text {\n  font-size: 13px;\n}\n\n.comm-edited-tag {\n  font-size: 10px;\n  margin-left: 6px;\n  padding: 0 4px;\n  line-height: 16px;\n  vertical-align: middle;\n  border-radius: 4px;\n}\n\n.comm-mine .comm-edited-tag {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  border: none;\n}\n\n.comm-theirs .comm-edited-tag {\n  background: #f1f5f9;\n  color: #64748b;\n  border: none;\n}\n\n/* Message Meta (Time & Status) */\n.comm-bubble-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: 4px;\n  font-size: 11px;\n}\n\n.comm-mine .comm-bubble-footer {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.comm-theirs .comm-bubble-footer {\n  color: #94a3b8;\n}\n\n.comm-check-icon {\n  font-size: 10px;\n  margin-left: 2px;\n}\n\n/* Message Actions */\n.comm-message-actions {\n  opacity: 0;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  display: flex;\n  align-items: center;\n  align-self: center;\n  padding: 0 2px;\n}\n\n.comm-message-row:hover .comm-message-actions {\n  opacity: 1;\n}\n\n.comm-msg-more-btn {\n  color: #94a3b8 !important;\n  border-radius: 50% !important;\n  width: 28px !important;\n  height: 28px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background: rgba(255, 255, 255, 0.8) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n.comm-msg-more-btn:hover {\n  color: #1e293b !important;\n  background: #ffffff !important;\n}\n\n/* Composer */\n.communication-composer {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  padding: 12px 18px 14px 18px;\n  border-top: 1px solid #eef2f6;\n  background: #ffffff;\n  flex-shrink: 0;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.02);\n}\n\n.comm-textarea {\n  border-radius: 20px !important;\n  padding: 9px 16px !important;\n  background: #f8fafc !important;\n  border: 1px solid #e2e8f0 !important;\n  font-size: 14px !important;\n  line-height: 1.4 !important;\n  resize: none !important;\n  transition: all 0.2s ease !important;\n  color: #1e293b !important;\n}\n\n.comm-textarea:focus,\n.comm-textarea-focused {\n  background: #ffffff !important;\n  border-color: #2a9dc0 !important;\n  box-shadow: 0 0 0 3px rgba(42, 157, 192, 0.15) !important;\n}\n\n.comm-send-button {\n  height: 40px !important;\n  width: 40px !important;\n  min-width: 40px !important;\n  border-radius: 50% !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  background: linear-gradient(135deg, #2a9dc0 0%, #157f9f 100%) !important;\n  border: none !important;\n  box-shadow: 0 3px 10px rgba(21, 127, 159, 0.28) !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  color: #ffffff !important;\n  padding: 0 !important;\n}\n\n.comm-send-button:hover:not(:disabled) {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 5px 14px rgba(21, 127, 159, 0.38) !important;\n  background: linear-gradient(135deg, #38abd0 0%, #178aa8 100%) !important;\n}\n\n.comm-send-button:active:not(:disabled) {\n  transform: translateY(0) !important;\n}\n\n.comm-send-button:disabled {\n  background: #e2e8f0 !important;\n  color: #94a3b8 !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
